import React from 'react';
import { StyledFilterSelectReset } from './FilterSelect.styles';
export const FilterSelectReset = ({ selectedFilterCount, setSelectedFilters }) => {
    return (React.createElement(StyledFilterSelectReset, null,
        React.createElement("span", { className: "reset", onClick: () => {
                setSelectedFilters([]);
            } }, "Reset"),
        React.createElement("span", null,
            " ",
            selectedFilterCount,
            " Selected ")));
};
//# sourceMappingURL=FilterSelectReset.js.map